import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import PandaMark from './brand/PandaMark';

const FooterContainer = styled.footer`
  background: var(--paper-raised);
  color: var(--body);
  border-top: 1px solid var(--hairline);
  padding: 4.5rem 0 2.5rem;
  position: relative;
  z-index: 10;
`;

const Content = styled.div`
  display: grid;
  grid-template-columns: 1.5fr 1fr 1fr;
  gap: 3rem;
  width: 90%;
  max-width: 1200px;
  margin: 0 auto;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 2.25rem;
  }
`;

const BrandCol = styled.div`
  max-width: 360px;
`;

const BrandRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.6rem;
  margin-bottom: 1.1rem;
`;

// Same as the nav: no plate behind the mark.
const Mark = styled.div`
  display: grid;
  place-items: center;
  width: 40px;
  height: 40px;
  svg { display: block; }
`;

const BrandName = styled.span`
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 1.2rem;
  letter-spacing: -0.02em;
  color: var(--ink);
`;

const Blurb = styled.p`
  color: var(--body);
  line-height: 1.7;
  font-size: 0.98rem;
`;

const ColTitle = styled.h3`
  font-family: var(--font-mono);
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--mute);
  margin-bottom: 1.25rem;
`;

const FLink = styled(Link)`
  display: block;
  color: var(--ink-soft);
  margin-bottom: 0.85rem;
  font-size: 0.98rem;
  width: fit-content;
  &:hover { color: var(--bamboo); }
`;

const FText = styled.p`
  color: var(--ink-soft);
  margin-bottom: 0.85rem;
  font-size: 0.98rem;
  a:hover { color: var(--bamboo); }
`;

const Copyright = styled.div`
  width: 90%;
  max-width: 1200px;
  margin: 3rem auto 0;
  padding-top: 1.75rem;
  border-top: 1px solid var(--hairline);
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  color: var(--mute);
  font-size: 0.85rem;

  @media (max-width: 768px) { flex-direction: column; text-align: center; }
`;

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <FooterContainer>
      <Content>
        <BrandCol>
          <BrandRow>
            <Mark aria-hidden="true">
              {/* Decorative: the adjacent brand name already carries the label. */}
              <PandaMark size={40} ink="var(--ink)" />
            </Mark>
            <BrandName>Panda Taps</BrandName>
          </BrandRow>
          <Blurb>
            Crafting delightful mobile experiences that users love. Our apps combine beautiful design with intuitive functionality.
          </Blurb>
        </BrandCol>

        <nav aria-label="Footer">
          <ColTitle>Navigation</ColTitle>
          <FLink to="/">Home</FLink>
          <FLink to="/apps">Our Apps</FLink>
          <FLink to="/contact">Contact</FLink>
        </nav>

        <div>
          <ColTitle>Contact Us</ColTitle>
          <FText><a href="mailto:support@pandataps.com">support@pandataps.com</a></FText>
          <FText>Chicago, IL</FText>
        </div>
      </Content>

      <Copyright>
        <span>&copy; {currentYear} Panda Taps LLC. All rights reserved.</span>
      </Copyright>
    </FooterContainer>
  );
};

export default Footer;
